module.exports = __webpack_public_path__ + "img/arrow-transfer.e077e089.svg";